import React, { useState, useEffect } from "react";
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem, { ListItemProps } from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { AppBar, Box, Button, Card, CardActions, CardContent, CardHeader, Container, CssBaseline, FormControlLabel, Grid, IconButton, LinearProgress, Link, TextField, Toolbar, Typography, withStyles } from "@material-ui/core";

import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import MaterialList from "./material/MaterialList";
import MaterialOrderList from './material/MaterialOrderList';
import MaterialOrderListTwo from './material/MaterialOrderList2';
import Scroll from "./material/Scroll";

import 'bootstrap/dist/css/bootstrap.min.css';

import Select from 'react-select';

import MenuIcon from '@material-ui/icons/Menu';
import ClearIcon from '@material-ui/icons/Clear';
import HeaderBar from "./header/HeaderBar";
import { TitleBackBar } from "./header/TitleBar";
import { useHistory } from "react-router-dom";
import { Dropdown, DropdownButton } from "react-bootstrap";
import ProductionList from "./product/ProductionList";
import SplashFoundation from "./SplashFoundation";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '80%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    textField: {

    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const Test: React.FC<any> = (props) => {
    const classes = useStyles();
    const history = useHistory()

    const {member} = props;

    return (
        <div className="content">
            <SplashFoundation member={member} companyName="test"/>
        </div>
    )
}

export default Test